import useScrollReveal from '@/hooks/useScrollReveal';
import styles from './index.module.scss';

export interface TechRowProps {
  title: string;
  description: string;
  image: string;
  reverse?: boolean;
}

export default function TechRow({ title, description, image, reverse = false }: TechRowProps) {
  const { ref, revealProps } = useScrollReveal<HTMLElement>();

  return (
    <article ref={ref} className={`${styles.row} ${reverse ? styles.reverse : ''}`} {...revealProps}>
      <div className={styles.visual}>
        <img src={image} alt={title} loading="lazy" />
      </div>
      <div className={styles.copy}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </article>
  );
}
